export default {
    data: function () {
        return {
            loading: this.$loading({
                fullscreen: true,
                text: '加载中',
            })
        }
    },
    methods: {
        payOrder: function () {
            this.$http.post(globalProvider.serviceUrl('e_reg/p/reg/v2'), {
                    r_i: this.$route.query.r_id,
                    bt: parseInt(this.$route.query.type),
                    n: this.$route.query.name?this.$route.query.name:"",
                    blu: this.$route.query.name?this.$route.query.name:"",
                    invoice_switch: parseInt(this.$route.query.invoice_switch),
                    tin: this.$route.query.code? this.$route.query.code:"",
                    email: this.$route.query.email?this.$route.query.email:"",
                    add: this.$route.query.add,
                    tel: this.$route.query.tel,
                    bank: this.$route.query.bank,
                    b_account: this.$route.query.b_account,
                    i_s: parseInt(this.$route.query.needOrNot)
                })
                .then((data) => {
                    if (data.body.code == resultCode.Success) {
                        location.href = data.body.data;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.loading.close();
                        if (data.body.message == "EXM_R_PRSH_02") {
                            this.$confirm('支付成功', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    window.opener = null;
                                    window.open('', '_self');
                                    window.close();
                                }
                            })
                        } else {
                            this.loading.close();
                            this.$confirm(getErrorMessage(data.body.message), '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    window.opener = null;
                                    window.open('', '_self');
                                    window.close();
                                }
                            })
                        }
                    }
                });
        }
    },
    created: function () {
        let batchCode = this.$store.state.examInfo.currentExamInfo.batchCode;
        if (this.$route.query.r_id) {
            this.payOrder()
        } else {
            this.loading.close();
            this.$router.push({
                name: batchCode?'batch_main':'main',
                params: {
                    projectCode: store.state.examInfo.currentExamInfo.domain,
                    batchCode:store.state.examInfo.currentExamInfo.batchCode
                },
            })
        }
    }
}